import React from 'react'
import { useTranslation } from 'react-i18next'

import { BodyText, Card, Heading } from '../../../../App/Components'

import { IProps } from './IProps'

export const SummaryCard = ({ totalPicks, from, to }: IProps) => {
  const { t } = useTranslation()

  return (
    <Card
      backgroundGradient="linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)"
      cardHeight="100%"
      cardWidth="100%"
      fontColor="white"
      hoverSensitive
      style={{ boxShadow: 'rgb(0 0 0 / 17%) 0px 41px 16px -27px' }}>
      <BodyText headingLevel="pageTitle">
        {t('Total picks for this range')}
      </BodyText>

      <Heading level="pageTitle">{totalPicks}</Heading>
      <BodyText headingLevel="pageTitle">
        {`${from.format('MMM Do YYYY')} ${to.format('MMM Do YYYY')}`}
      </BodyText>
    </Card>
  )
}
